const { REACT_APP_API_BASE_URL: apiBaseUrl } = process.env;

export const { origin: BASE_URL } = window.location;
export const API_BASE_URL = apiBaseUrl || BASE_URL;
